var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"c-form_tag",class:{
  'c-form_tag--fade_in' : _vm.fadeIn,
  'c-form_tag--fade_out' : _vm.fadeOut }},[_c('span',{staticClass:"c-form_tag__name"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('button',{staticClass:"c-form_tag__delete tagDelete",attrs:{"type":"button","tabindex":"-1"},on:{"click":_vm.remove}})])
}
var staticRenderFns = []

export { render, staticRenderFns }